<div [dfs]="'d:contents'">
    <ng-template iCmsUtilViewContainer></ng-template>
</div>